import React, { useState } from "react";
import ParentPanel from "../panel/ParentPanel";
import "../styles/JoinLiveClass.css";
import { FaChalkboardTeacher } from "react-icons/fa";
import api from "../../../api/api";

const JoinLiveClass = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null); // For modal

  const classes = [
    { subject: "Maths", grade: "10", status: "Live", emoji: "📐", img: "/images/maths.png" },
    { subject: "Sci", grade: "9", status: "Upcoming", emoji: "🧪", img: "/images/science.png" },
    { subject: "Eng", grade: "8", status: "Ended", emoji: "📖", img: "/images/english.png" },
    { subject: "Hist", grade: "10", status: "Upcoming", emoji: "🏛️", img: "/images/history.png" },
    { subject: "Geo", grade: "9", status: "Live", emoji: "🌍", img: "/images/geography.png" },
    { subject: "CSE", grade: "9", status: "Upcoming", emoji: "💻", img: "/images/computer.png" },
    { subject: "Art", grade: "9", status: "Live", emoji: "🎨", img: "/images/art.png" },
    { subject: "P.E", grade: "9", status: "Ended", emoji: "🏀", img: "/images/pe.png" },
  ];

  const cardColors = [
    "#5c3dc4",
    "#ff6b6b",
    "#ffa500",
    "#4caf50",
    "#00bfff",
    "#e43972ff",
    "#81b348ff",
    "#9c27b0",
  ];

  const statusOrder = { Ended: 0, Live: 1, Upcoming: 2 };
  const sortedClasses = classes.sort(
    (a, b) => statusOrder[a.status] - statusOrder[b.status]
  );

  return (
    <>
      {/* ✅ Sidebar */}
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      {/* ✅ Main Content */}
      <div
        className={`join-live-content ${
          isSidebarCollapsed ? "collapsed" : ""
        }`}
      >
        <div className="dashboard-topbar">
          <span className="date-time">
            TODAY IS {new Date().toLocaleString()}
          </span>
          <span className="school-name">Semigon Learning ERP</span>
        </div>

        <h3 className="dashboard-title">Join Live Classes</h3>

        <div className="classes-grid">
          {sortedClasses.map((cls, index) => (
            <div
              key={index}
              className="class-card"
              style={{
                backgroundColor: cardColors[index % cardColors.length],
              }}
            >
              <div className="sr-left1">
                <div className="sr-label1">
                  {cls.emoji} {cls.subject} - Grade {cls.grade}
                </div>
                <button
                  className={`sr-count1 ${
                    cls.status === "Live"
                      ? "live"
                      : cls.status === "Upcoming"
                      ? "upcoming"
                      : "ended"
                  }`}
                  onClick={() => cls.status === "Live" && setSelectedClass(cls)}
                >
                  {cls.status === "Live"
                    ? "Join Now "
                    : cls.status === "Ended"
                    ? "Ended "
                    : "Upcoming ⏳"}
                </button>
              </div>
              <div className="sr-icon-chip1">
                <FaChalkboardTeacher />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ✅ Modal for Join Options */}
      {selectedClass && (
        <div
          className="join-modal-overlay"
          onClick={() => setSelectedClass(null)}
        >
          <div className="join-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Join {selectedClass.subject} Class</h2>
            <p>Select a platform to join:</p>
            <div className="join-links">
              <a
                href="https://meet.google.com"
                target="_blank"
                rel="noreferrer"
                className="join-btn google"
              >
                Google Meet
              </a>
              <a
                href="https://teams.microsoft.com"
                target="_blank"
                rel="noreferrer"
                className="join-btn teams"
              >
                Microsoft Teams
              </a>
              <a
                href="https://zoom.us"
                target="_blank"
                rel="noreferrer"
                className="join-btn zoom"
              >
                Zoom
              </a>
            </div>
            <button className="close-btn" onClick={() => setSelectedClass(null)}>
              Close{" "}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default JoinLiveClass;
